import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

export interface I_AttendeeInfo {
  email: string;
  name?: string;
}

const MeetingTranscriptSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: true,
    ref: EModelName.USER,
  },
  transcript: { type: [mongoose.Schema.Types.Mixed] },
  summary: { type: String, required: true },
  detailedSummary: { type: String },
  meetingId: { type: String },
  botId: { type: String },
  meetingTitle: { type: String },
  meetingDate: { type: Date },
  attendees: { type: [mongoose.Schema.Types.Mixed] },
  created: { type: Date, default: Date.now() },
});

export type T_MeetingTranscriptBase = InferSchemaType<typeof MeetingTranscriptSchema>;

// Extend the type to provide proper typing for transcript and attendees
export interface T_MeetingTranscript extends Omit<T_MeetingTranscriptBase, 'transcript' | 'attendees'> {
  transcript?: {
    speaker: string;
    text: string;
  }[];
  attendees?: I_AttendeeInfo[];
}

export type T_MeetingTranscriptDocument = T_MeetingTranscript &
  Document & {
    _id: string;
  };

export { MeetingTranscriptSchema };
